export const getSsoErrorFromSearch = (search) => {
  const params = new URLSearchParams(search || '');
  const errorDescription = params.get('error_description');
  const errorCode = params.get('error');

  if (!errorDescription && !errorCode) {
    return '';
  }

  return errorDescription || `SSO error: ${errorCode}`;
};

export const hasPendingSsoCallbackParams = (search) => {
  const params = new URLSearchParams(search || '');

  return ['code', 'state', 'id_token', 'access_token'].some((param) => params.has(param));
};
